import { getApiCall } from "./tokenService";
import { IHourBookingCategoryItem } from "../models/hourBookingType/hourBookingTypeItem";

export const getHourBookingTypes = (
    signal?: AbortSignal
): Promise<IHourBookingCategoryItem[]> => {
    return getApiCall<IHourBookingCategoryItem[]>(
        "api/hourbooking/types",
        null,
        signal
    );
};
